import React from 'react';
import { Tabs } from '@/shared/components/ui/Tabs';
import type { IconName } from '@/shared/icons';

export type SectionKey = 'overview' | 'metrics' | 'posts' | 'comments' | 'activity' | 'sync';

interface Item {
  key: SectionKey;
  label: string;
  icon: IconName;
  requiresInsights?: boolean;
}
const ITEMS: Item[] = [
  { key: 'overview', label: 'Visão geral', icon: 'grid' },
  { key: 'metrics', label: 'Métricas', icon: 'bar-chart', requiresInsights: true },
  { key: 'posts', label: 'Publicações', icon: 'image', requiresInsights: true },
  { key: 'comments', label: 'Comentários', icon: 'message-circle', requiresInsights: true },
  { key: 'activity', label: 'Atividade', icon: 'activity', requiresInsights: true },
  { key: 'sync', label: 'Sync', icon: 'refresh' },
];

interface Props {
  active: SectionKey;
  onSelect: (k: SectionKey) => void;
  capabilities: string[];
}

/**
 * Abas de página do dashboard do canal — Tabs shared pageLevel/fullBleed (F55).
 * Conteúdo das seções é renderizado pela própria página (Tabs usado como barra controlada).
 */
export const SectionNav: React.FC<Props> = ({ active, onSelect, capabilities }) => {
  const hasInsights = capabilities.includes('get_insights');
  return (
    <div className="flex-none" data-testid="cdash-nav">
      <Tabs
        variant="underline"
        pageLevel
        fullBleed
        activeTab={active}
        onChange={(tabId) => onSelect(tabId as SectionKey)}
        tabs={ITEMS.filter((i) => !(i.requiresInsights && !hasInsights)).map((i) => ({
          id: i.key,
          label: i.label,
          icon: i.icon,
          content: null,
          'data-testid': `cdash-nav-${i.key}`,
        }))}
      />
    </div>
  );
};
